import firebase from '../../firebase';

const fetchLearnedMapping = async (data) => {
    const mapping = await firebase.functions().httpsCallable('getLearnedImportMapping')(data);
    return mapping && mapping.data;
};

export default fetchLearnedMapping;
